import React from 'react';
import { clsx } from 'clsx';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  ...props
}) => {
  const variants = {
    primary: 'courtyard-btn-primary',
    secondary: 'courtyard-btn-secondary',
    ghost: 'courtyard-btn-ghost',
    philemon: 'courtyard-btn bg-gradient-to-r from-courtyard-olive-dark to-courtyard-olive text-white hover:shadow-courtyard-md hover:-translate-y-0.5 px-6 py-3',
    xenia: 'courtyard-btn bg-gradient-to-r from-courtyard-aegean-dark to-courtyard-aegean text-white hover:shadow-courtyard-md hover:-translate-y-0.5 px-6 py-3',
    theron: 'courtyard-btn bg-gradient-to-r from-courtyard-clay to-courtyard-terracotta-dark text-white hover:shadow-courtyard-md hover:-translate-y-0.5 px-6 py-3',
  };

  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: '',
    lg: 'text-lg px-8 py-4',
  };

  return (
    <button
      className={clsx(variants[variant], sizes[size], className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
